import React from "react";

interface CardProps {
  children: React.ReactNode;
  className?: string;
}

const OnboardingCard: React.FC<CardProps> = ({ children, className = "" }) => {
  return (
    <div
      className={`w-full rounded-none bg-white border-[2px] border-[#A2B2C833] shadow-[0px_7.16px_35.82px_0px_#1A1F3C0D] relative ${className}`}
    >
      <div 
        className="absolute top-0 left-0 right-0 h-[8px] bg-[#E2B042]"
      />
      {children}
    </div>
  );
};

export default OnboardingCard;